import axios from "axios";
import { adminApiUrl, publicApiUrl, signedInApiUrl, superAdminApiUrl } from "../util/Constants";
import type { UnlinkedUser } from "../types/domain";

export interface UserSummary {
  id: number;
  username: string;
  playerId: number | null;
  playerFirstname: string | null;
  playerLastname: string | null;
  playerNickname: string | null;
}

type Role = "USER" | "ADMIN";

export const usersApi = {
  register: async ({ username, password }: { username: string; password: string }): Promise<string> => {
    const { data } = await axios.post<string>(`${publicApiUrl}/users/register`, { username, password });
    return data;
  },

  setRole: async ({ userId, role }: { userId: number; role: Role }): Promise<unknown> => {
    const { data } = await axios.post(`${superAdminApiUrl}/users/${userId}/set-role`, { role });
    return data;
  },

  recalculateElo: async (): Promise<unknown> => {
    const { data } = await axios.post(`${superAdminApiUrl}/tasks/recalculateElo`);
    return data;
  },

  fetchUnlinked: async (includedUserId: number | null = null): Promise<UnlinkedUser[]> => {
    let url = `${adminApiUrl}/users/unlinked`;
    if (includedUserId) url += `?includedUserId=${includedUserId}`;
    const { data } = await axios.get<UnlinkedUser[]>(url);
    data.sort((a, b) => (a.username ?? "").localeCompare(b.username ?? ""));
    return [{ id: null }, ...data];
  },

  list: async (): Promise<UserSummary[]> => {
    const { data } = await axios.get<UserSummary[]>(`${signedInApiUrl}/users`);
    return data;
  },
};
